import React, { useEffect, useState } from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import { useLocation } from 'react-router-dom';
import Header from '../../layout/dashboard/header';
import { InputCustom } from '../../components/UIElements/input-ui';
import EmploymentDetailsContent from '../../components/employment/EmploymentDetailsContent';
import { apiGetEmploymentById } from '../../api/employment';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../../hooks/useAuth';
import { getUrlPathId } from '../../utils/url-id';
import { useNotificationService } from '../../components/notification';
import {
  employmentDetailsData,
  EmploymentDetailsProps,
} from '../../interface/employment';
import BackButton from '../../components/UIElements/BackButton';

const EmploymentDetails = () => {
  const theme = useTheme();
  const location = useLocation();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');

  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [employee_info, setEmployee_info] = useState<EmploymentDetailsProps>(
    employmentDetailsData
  );
  const [modal_status, setModal_status] = useState('');

  useEffect(() => {
    const employmentId = getUrlPathId(location?.pathname);
    const fields = { employmentId, token };
    mutation.mutate(fields);
  }, []);

  const mutation = useMutation({
    mutationFn: (fields: { token: string; employmentId: string }) =>
      apiGetEmploymentById(fields),
    onSuccess: (data) => {
      if (data?.status === 'error') {
        if ('msg' in data) {
          showNotification(data?.msg ?? '', 'error');
          return;
        }
        return;
      }
      if ('data' in data) {
        if (Array.isArray(data?.data?.data)) {
          setEmployee_info(data.data.data[0]);
        } else {
          setEmployee_info(data.data.data);
          setModal_status(data.data.data?.status ?? '');
        }
      }
    },
    onError: (error) => {
      console.error('Fetch process failed', error);
      showNotification('Fetch process failed', 'error');
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginRight: '1rem',
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px' }}>
            <BackButton />
            <Typography
              variant={'subtitle1'}
              sx={{
                fontWeight: 500,
                fontFamily: 'Lexend',
                color: '#2F66F4',
              }}
            >
              Employment
            </Typography>
            {!isSmall && (
              <InputCustom
                type="text"
                placeholder="Search Employment..."
                value=""
                onchange={() => {}}
                styles={{
                  width: isMedium ? 200 : 400,
                }}
              />
            )}
          </Stack>
        </Box>
      </Header>
      <EmploymentDetailsContent
        modalStatus={modal_status}
        setModalStatus={setModal_status}
        employee_info={employee_info}
        loading={mutation.isPending}
      />
    </>
  );
};

export default EmploymentDetails;
